import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';
import { DepotMasterClass, DepotMasterTab1 } from 'src/app/models/Depot_Master_Model/depot-master-tab1';
import { Locationport } from 'src/app/models/Depot_Master_Model/locationport';
import { BackendListModel } from 'src/app/models/common/list.model';
import { DomainCode } from 'src/app/models/common/model';
import { ContactsModel } from 'src/app/models/contacts';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { DepotMasterApiService } from 'src/app/services/domain_code/depot-master-api.service';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';

@Component({
  selector: 'logzy-depot-form',
  templateUrl: './depot-form.component.html',
  styleUrls: ['./depot-form.component.scss']
})
export class DepotFormComponent implements OnInit {

  @Input() data = new Subject<string>();
  @Output() depotAdded = new EventEmitter<any>()
  canvas: string = "Canvas";
  open1: string = "sidepanel";
  currentDate = new Date();

  keysToTransformTab1;
  stateUrl: string;
  country_url = ApiRoutes.Geo;
  stateDisabled: boolean = true;
  depotCreated: boolean = false;
  isSavebutton :boolean = true;
  portCreated: boolean = false;

  dd_billDepots;
  dd_depotTypes;
  // dd_depotTypes: BackendListModel<DomainCode>;
  base_url = ApiRoutes.DepotMaster;
  @Input() isEditable: boolean = true;
  locationPorts: any[] = [];
  @Output() close: EventEmitter<any> = new EventEmitter();
  depotResponse;

  constructor(private _snackBar: MatSnackBar, private depotMasterService: DepotMasterApiService,
    private domainService: DomainCodeApiService) { }

  depotFormObject: DepotMasterTab1 = {
    id: null,
    name: null,
    location_type: 'depot',
    depot_owner_type: null,
    local_name: null,
    address: null,
    agreement_valid_date: this.currentDate,
    location_billing_type: null,
    location_email: null,
    location_contact_no: null,
    working_hrs_from: null,
    working_hrs_to: null,
    week_offs: null,
    is_edi_available: false,
    edi_code: null,
    remarks: null,
    country: null,
    state: null,
    depot_week_offs: '',
    ports: [],
    connectivities: [],
    free_storage_days_upto_teus:null,
    is_active: true
  }

  defaultPort: Locationport = {
    id: null,
    name_display: null,
    updated_at: null,
    created_at: null,
    is_active: true,
    is_primary: true,
    location: null,
    port: null,
    distance_in_km: 0
  }

  contactObject: ContactsModel = {
    id: null,
    first_name: null,
    last_name: null,
    profile: null,
    email: null,
    phone: null,
    enable_email_notification: null,
    address: null,
    function: null,
    location: null,
    is_active: true,
  }
  errorObj: any = {};

  ngOnInit(): void {
    console.log("data in depot form", this.data)
    this.getDepotTypes();
    this.getBillDepot();
    this.data.subscribe(item => {
      this.depotFormObject.name = item;
      console.log("this.depotObject.name", this.depotFormObject.name)
    })
  }

  getBillDepot() {
    this.domainService.getByGroup('DepotBillingCycle').subscribe(response => {
      this.dd_billDepots = response.results;
      this.depotFormObject.location_billing_type = response.results[0].id;

    })
  }

  getDepotTypes() {
    this.domainService.getByGroup('DepotOwnerType').subscribe(response => {
      this.dd_depotTypes = response.results;
      for (let i = 0; i < response.results.length; i++) {
        if (response.results[i].sequence_no == 2000) {
          this.depotFormObject.depot_owner_type = response.results[i].id;
        }
      }
      // this.depotFormObject.depot_owner_type = response.results[1].id;

    })
  }

  filterStatebyCountryID(country) {
    if (country !== null) {
      this.stateUrl = `${this.country_url}state/?name=::search::&country=${country.id}`;
      this.depotFormObject.state = null
      this.stateDisabled = false;
    }
    if (country == null) {
      this.depotFormObject.state = null;
      this.stateUrl = null;
      this.stateDisabled = true;
    }
  }
  onStateChange(state) {
    if (state != null) {
        this.depotFormObject.state = state;
        this.depotFormObject.address = `${this.depotFormObject.state != null ? this.depotFormObject.state.name + ', ' : ''}${this.depotFormObject.country != null ? this.depotFormObject.country.name : ''}`
    }
}
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      return error;
    }
  }

  saveDepot() {

    this.keysToTransformTab1 = [
      'state',
      'country',
      // 'depot_owner_type',
      // 'location_billing_type',
    ];
    let payload = { ...this.depotFormObject };
    for (const key of this.keysToTransformTab1) {
      if (payload[key] != null && payload[key] != '')
        payload[key] = payload[key].id;
    }
    payload['location_type'] = "depot";
    if (payload.id != null) {
      // this.updateDepotformTab1(payload.id, payload);
    } else {
      this.postDepotformTab1(payload);
    }
  }
  editDepotMaster(element) {
    this.depotFormObject = JSON.parse(JSON.stringify(element));
    // this.depotAdded.emit(element);
  }
  postDepotformTab1(data) {
    this.depotMasterService.depotCreateTab1(data).subscribe({
      next: response => {
        this._snackBar.open("Depot created Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.depotResponse = response;
        this.isSavebutton = false;
        this.depotCreated = true;
        this.depotMasterService.updateDepotSubjectValue(response);
        this.Defaultport();
        // this.closeDepotForm();
        // this.close.emit();
      },
      error: error => {
        this.depotCreated = false;
        return this.catchError(error);
      }
    });
  }

  closeEdit() {
    this.open1 = " sidepanel ";
    this.canvas = "Canvas ";
    this.data.next(null);
  }
  // bindRequestor(event) {
  //   if (event != null) {
  //     this.depotObject.name = event;
  //     this.closeEdit();
  //   }
  // }
  edit(i) {
    document.getElementById(`fci${i}`)!.classList.add("flip");
    setTimeout(() => {
      document.getElementById(`fci${i}`)!.classList.add("hideFront");
    }, 600)
  }
  addDefaultPort() {
    this.locationPorts.push({ ... this.defaultPort });
    setTimeout(() => {
      this.edit(this.locationPorts.length - 1);
    }, 200)
  }
  Defaultport() {
    if (this.locationPorts.length == 0) {
      this.addDefaultPort();
    }
    else if (this.locationPorts[this.locationPorts.length - 1].port != null && this.locationPorts[this.locationPorts.length - 1].name_display != null) {
      this.addDefaultPort();
    }
    else {
      this._snackBar.open("You already have unfinished data of port-mapping. Complete that first to add the second mapping!", 'Close', {
        verticalPosition: 'top',
        duration: 3000,
      });
    }

  }

  postlocationPortMapping(data, index) {
    data['location'] = this.depotResponse.id;
    this.depotMasterService.postLocationportMapping(data).subscribe({
      next: response => {
        this._snackBar.open("Port Post Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.locationPorts[index] = response;

        this.errorObj = {};
        // this.depotAdded.emit(this.depotResponse);
        // this.close.emit();
        // data['location'] = null;
        // data['name_display'] = null;
        // data['distance_in_km'] = null;
        // data['port'] = null;
        // this.depotFormObject['name'] = null;
        // this.depotFormObject['country'] = null;
        // this.depotFormObject['state'] = null;
        // this.depotFormObject['address'] = null;
        // this.locationPorts.length = 0;
        this.isSavebutton = true;
        // this.depotCreated = false;
        this.portCreated = true;
        // this.resetComponent();

      }, error: error => {
        document.getElementById(`fci${index}`)!.classList.add("hideFront");
        document.getElementById(`fci${index}`)!.classList.add("flip");
        this.locationPorts[index].errorObj = error.error;
        this.portCreated = false;
        return this.catchError(error);
      }
    })
  }

  onPortsSave(item, index) {
    document.getElementById(`fci${index}`)!.classList.remove("hideFront");
    document.getElementById(`fci${index}`)!.classList.remove("flip");
    if (this.isEditable == true) {

      if (item.is_active == false) { // Set primary port as false if is_active is false
        item.is_primary = false;
      }
      setTimeout(() => {
        if (item.id != null) {
          // this.updatelocationPortMapping(item, index);

        } else {
          this.postlocationPortMapping(item, index);
        }
      }, 600)
    }
  }
  resetComponent() {
    this.errorObj = {};
    this.depotFormObject = { ...this.depotFormObject };
    this.contactObject = { ...this.contactObject };

    this.addDefaultPort();
  }

  postContact(data) {
    data['location'] = this.depotResponse.id;
    this.depotMasterService.postdepotCreateContacts(data).subscribe({
      next: response => {
        this._snackBar.open("Contact successfully updated.", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.depotMasterService.updateContactSubjectValue(response);

        data['location'] = null;
        data['name_display'] = null;
        data['distance_in_km'] = null;
        data['port'] = null;
        this.depotFormObject['name'] = null;
        this.depotFormObject['country'] = null;
        this.depotFormObject['state'] = null;
        this.depotFormObject['address'] = null;
        this.locationPorts.length = 0;
        this.contactObject = { ...this.contactObject };

        this.close.emit();
        this.portCreated = false;

      }, error: error => {
        return this.catchError(error);
      }
    });
  }
}
